import { render, staticRenderFns } from "./register-account.vue?vue&type=template&id=952231c6&scoped=true"
import script from "./register-account.vue?vue&type=script&lang=js"
export * from "./register-account.vue?vue&type=script&lang=js"
import style0 from "./register-account.vue?vue&type=style&index=0&id=952231c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952231c6",
  null
  
)

export default component.exports